export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/unlock_cta_golden_bg-ee4009876a30db8dc022c14b0d224259.png";